var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6423 17.4754C18.7023 15.6437 20 12.9734 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 12.9734 1.29773 15.6437 3.35769 17.4754C3.44997 17.5575 3.54378 17.6378 3.63907 17.7165C5.36691 19.1424 7.58185 19.9993 9.99688 20H10C10.0108 20 10.0216 20 10.0323 19.9999C12.5691 19.9919 14.8835 19.0393 16.6423 17.4754ZM10 18.5C11.8476 18.5 13.5575 17.9105 14.9519 16.9094C15.6521 16.4067 15.8043 15.4366 15.2823 14.7506C15.176 14.6109 15.0651 14.475 14.9498 14.3431C13.637 12.8429 11.8565 12 10 12C8.14349 12 6.36301 12.8429 5.05026 14.3431C4.93493 14.475 4.82404 14.6109 4.71769 14.7506C4.19571 15.4366 4.34791 16.4067 5.04814 16.9094C6.44254 17.9105 8.15243 18.5 10 18.5ZM12.5 8.5C12.5 9.88071 11.3807 11 10 11C8.61929 11 7.50001 9.88071 7.50001 8.5C7.50001 7.11929 8.61929 6 10 6C11.3807 6 12.5 7.11929 12.5 8.5Z",
    fill: "#91979E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/UserCircle.386fe65e7717dca100fc22dbd16b1fcb.svg";
export { ForwardRef as ReactComponent };